// Конфигурация Робокассы
// ВАЖНО: Password #1 и Password #2 НЕ хранятся здесь - они используются только на backend

export const ROBOKASSA_CONFIG = {
  MERCHANT_LOGIN: 'annavision_9palaces',
  PAYMENT_URL: 'https://auth.robokassa.ru/Merchant/Index.aspx',
  AMOUNT: 21739.00,
  DESCRIPTION: 'Персональный прогноз по 9 Дворцам на 2026 год',
  CULTURE: 'ru',
  ENCODING: 'utf-8',
  SUCCESS_URL: 'https://annavision.me/9palaces/thank-you',
  FAIL_URL: 'https://annavision.me/av_9palaces_calc/',
};

export const EXECUTOR_DETAILS = {
  FULL_NAME: 'Калмыкова Анна Александровна',
  INN: '745109437025',
  LEGAL_STATUS: 'самозанятая (налоговый режим — НПД)',
  EMAIL: 'keys@annavision.me',
  WEBSITE: 'www.annavision.me',
  OFFER_URL: 'https://annavision.me/9palaces/oferta/',
};

